import { useNavigate } from 'react-router-dom';
import FoxMark from '../components/shared/FoxMark.jsx';

const PAPER = '#F2EBDC';
const INK = '#1B1814';

export default function SubscribeCancel() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        background: PAPER,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 32,
        textAlign: 'center',
      }}
    >
      <div style={{ marginBottom: 24 }}>
        <FoxMark variant="gold" size={52} />
      </div>
      <h1
        style={{
          fontFamily: 'Georgia, serif',
          fontSize: 26,
          fontWeight: 300,
          color: INK,
          marginBottom: 12,
        }}
      >
        No worries
      </h1>
      <p
        style={{
          fontSize: 15,
          color: INK,
          opacity: 0.6,
          fontFamily: 'Georgia, serif',
          fontStyle: 'italic',
          lineHeight: 1.7,
          maxWidth: 320,
          marginBottom: 32,
        }}
      >
        Your study is still here whenever you are ready to continue.
      </p>
      <button
        type="button"
        onClick={() => navigate('/study')}
        style={{
          background: INK,
          color: PAPER,
          border: 'none',
          borderRadius: 12,
          padding: '14px 32px',
          fontSize: 16,
          cursor: 'pointer',
          fontWeight: 600,
        }}
      >
        Back to my study
      </button>
    </div>
  );
}
